export default "__VITE_ASSET__1094fae7__"